import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import ym from 'react-yandex-metrika';

import { getClasses } from 'common.components/user/selectors';
import { getTeamIdFromPath } from 'utils/path';

// отправляет в метрику номер класса, с которым работает учитель
export const TrackTeacherGradeActivity = () => {
    const location = useLocation();
    const teams = useSelector(getClasses);
    const [teamId, setTeamId] = useState<number | null>(null);
    useEffect(() => setTeamId(getTeamIdFromPath()), [location]);
    useEffect(() => {
        const currentTeamLevel = teams?.find((team) => team.id === teamId)?.level;
        if (currentTeamLevel) {
            ym('reachGoal', 'teacher_grade_activity', { grade_activity: currentTeamLevel });
        }
    }, [teams, teamId]);
    return null;
};
